import {getExampleNumber} from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
import {match} from 'ts-pattern';

import {Alpha3CountryCode, getAlpha2CodeByAlpha3code} from './countryCodes';

/**
 * @about Returns an example phone number of the given country, formatted the same way as
 * the input formats what the user types — international by default, national on demand.
 */
export const getPhoneNumberPlaceholder = (
  country: Alpha3CountryCode,
  isNational?: true
): string | undefined => {
  const exampleNumber = getExampleNumber(getAlpha2CodeByAlpha3code(country), examples);

  return match(isNational)
    .with(true, () => exampleNumber?.formatNational())
    .otherwise(() => exampleNumber?.formatInternational());
};
